import { navbar } from './navbar';
import { backtotop } from './backtotop';

window.navbar = navbar;
window.backtotop = backtotop;
